import type { FC, SetStateAction } from "react";

import DialogCustom from "@/components/modals/dialog-custom";
import SubmitModalFooter from "@/components/modals/submit-modal-footer";
import { Separator } from "@/components/ui/separator";

type GenericModalProps = {
  title: string;
  description?: string;
  submitLabel?: string;
  logo: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  handleSubmit?: () => Promise<void>;
  onClick?: () => void;
  children: React.ReactNode;
  isSubmitPending?: boolean;
};

const GenericModal: FC<GenericModalProps> = ({
  title,
  description,
  submitLabel = "Générer",
  logo,
  open,
  setOpen,
  handleSubmit,
  onClick,
  children,
  isSubmitPending = false,
}) => {
  return (
    <DialogCustom
      title={title}
      startIcon={
        <div className="flex p-3 w-12 h-12 justify-center items-center border border-gray-200 rounded-[10px]">
          {logo}
        </div>
      }
      description={description}
      open={open}
      onOpenChange={setOpen}
      className="flex flex-col gap-4"
    >
      <Separator className="col-span-full bg-gray-200" />
      {children}
      <Separator className="col-span-full bg-gray-200" />
      <SubmitModalFooter
        setOpen={setOpen}
        handleSubmit={handleSubmit}
        onClick={onClick}
        submitLabel={submitLabel}
        isSubmitPending={isSubmitPending}
      />
    </DialogCustom>
  );
};

export default GenericModal;
